export default __webpack_public_path__ + "static/media/solid.7613a94f.svg";